import type { SVGProps } from 'react';

const SvgProtected = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="m17.82 4.54-5-1.42c-.54-.15-1.11-.15-1.65 0L6.18 4.54A3.02 3.02 0 0 0 4 7.43V11c0 6.66 7.31 9.72 7.62 9.85.12.05.25.07.38.07s.26-.02.38-.07C12.69 20.72 20 17.67 20 11V7.43c0-1.33-.89-2.52-2.18-2.88zM18 11c0 4.55-4.63 7.15-6 7.82-1.37-.67-6-3.27-6-7.82V7.43c0-.44.3-.84.72-.96l5-1.43c.09-.03.18-.04.28-.04s.19.01.28.04l5 1.43c.43.12.72.52.72.96z"
    />
    <path
      fill="currentcolor"
      d="M14.29 9.29 12 11.58l-.96-.96a.996.996 0 1 0-1.41 1.41l1.67 1.67c.2.2.45.29.71.29s.51-.1.71-.29l3-3a.996.996 0 1 0-1.41-1.41z"
    />
  </svg>
);
export default SvgProtected;
